import { getRequest } from 'utils/http'

export const getMemberCourseStatusApi = () => {
  return getRequest(`/users/course-status`)
}

export const getCoachCourseStatusApi = userId => {
  return getRequest(`/users/course-status/${userId}`)
}
